module.exports = __webpack_public_path__ + "static/media/Luci Laffitte.736dda41.png";